/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import AdminLayout from "../../../components/AdminLayout/AdminLayout";

function MandalTable() {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [mandals, setMandals] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);
  
  useEffect(() => {
    handleSearch();
  }, [search, mandals]);

  const fetchRecords = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${apiUrl}/MandalDetails/Get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data?.data || [];
      setMandals(data);
      setFilteredData(data);
      setLoading(false);
      // console.log(data);
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
    }
  };

  const handleSearch = () => {
    if (!search) {
      setFilteredData(mandals);
      return;
    }

    const lowercasedSearch = search.toLowerCase();

    const filtered = mandals.filter((row) => {
      const name = `${row.name}`.toLowerCase();
      const area = `${row.area}`.toLowerCase();
      const description = `${row.description}`.toLowerCase();

      return (
        name.includes(lowercasedSearch) ||
        area.includes(lowercasedSearch) || 
        description.includes(lowercasedSearch)
      );
    });

    setFilteredData(filtered);
  };

  // Function to handle deletion of a record
  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");

    // Show confirmation dialog
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (!confirmed) return; 

    try {
      const response = await axios.delete(`${apiUrl}/MandalDetails/Delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Record deleted successfully");
      console.log("Response:", response.data); // Log response
      fetchRecords(); // Refresh the list after deletion
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.response?.data?.message || "Failed to delete record");
    }
  };

  const columns = [
    {
      name: "No",
      selector: (_, index) => (currentPage - 1) * rowsPerPage + index + 1, // Adjust index based on pagination
      sortable: true,
      width: "65px",
      center: "true",
    },
    {
      name: "Mandal Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Mandal Area",
      selector: (row) => row.area,
      sortable: true,
    },
    {
      name: "Mandal Description",
      selector: (row) => row.description,
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm mr-1"
            onClick={() =>
              navigate("/update-mandal1", { state: { id: row.id } })
            }
          >
            <i className="fas fa-pen"></i>
          </button>

          <button
            type="button"
            className="btn btn-danger btn-sm mr-1"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => navigate("/mandal-info1", { state: { id: row.id } })}
          >
            <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      ),
      center: "true",
    },
  ];

  return (
    <AdminLayout ac8="active">
      <section className="content-header pb-0">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h5>Mandal</h5>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/admin-dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Mandal List</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    <div className="bd-highlight">
                    <input
                        className="form-control mb-3"
                        type="search"
                        placeholder="Search"
                        title="Search within table"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    <div className="bd-highlight"></div>
                    <div className="bd-highlight">
                      <Link to="/add-mandal1">
                      <button
                          type="button"
                          className="btn btn-primary px-md-4 py-md-2 px-2 py-2"
                        >
                          <i className="fas fa-plus"></i> Add
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card-body text-center">
                  {loading ? (
                    <> <span className="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span></>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      responsive
                      className="custom-table"
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newPerPage) => {
                        setRowsPerPage(newPerPage);
                        setCurrentPage(1);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </AdminLayout>
  );
}

export default MandalTable;
